// import { useState, useEffect } from "react";
// import "../index.css";

// export default function Navbar() {
//   const [active, setActive] = useState("home");
//   const [scrolled, setScrolled] = useState(false);

//   const navItems = [
//   { id: "home", label: "Главная" },
//   { id: "about", label: "О нас" },
//   { id: "contact", label: "Контакты" },
// ];

// useEffect(() => {
//   const handleScroll = () => {
//     setScrolled(window.scrollY > 60);

//     const sections = ["home", "about", "contact"];
//     const scrollPosition = window.scrollY + 120;

//     for (let section of sections) {
//       const element = document.getElementById(section);
//       if (!element) continue;

//       const offsetTop = element.offsetTop;
//       const offsetHeight = element.offsetHeight;

//       if (
//         scrollPosition >= offsetTop &&
//         scrollPosition < offsetTop + offsetHeight
//       ) {
//         setActive((prev) => {
//           if (prev !== section) {
//             window.history.replaceState(
//               null,
//               "",
//               `${window.location.pathname}#${section}`
//             );
//             return section;
//           }
//           return prev;
//         });

//         break;
//       }
//     }
//   };

//   window.addEventListener("scroll", handleScroll);
//   handleScroll();

//   return () => window.removeEventListener("scroll", handleScroll);
// }, []);

//   return (
//     <nav style={{ ...navStyle, ...(scrolled ? navScrolled : {}) }}>
//       <div style={logoStyle}>
//         <img alt="logo" src="gxp-logo.png" style={imageStyle} />
//       </div>

//       <div style={linksContainer}>
//         {navItems.map((item) => (
//           <a
//             key={item.id}
//             href={`#${item.id}`}
//             style={{
//               ...linkStyle,
//               ...(active === item.id ? activeLink : {}),
//             }}
//           >
//             {item.label}
//           </a>
//         ))}
//       </div>
//     </nav>
//   );
// }

// /* ===== STYLES ===== */

// const navStyle = {
//   position: "fixed",
//   top: 0,
//   width: "100%",
//   height: "85px",
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   padding: "0 80px", 
//   boxSizing: "border-box",
//   transition: "all 0.4s ease",
//   zIndex: 1000,
//   backgroundColor: "rgba(255,255,255,0.75)",
//   backdropFilter: "blur(12px)",
// };

// const navScrolled = {
//   height: "70px",
//   boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
//   backgroundColor: "rgba(255,255,255,0.95)",
// };

// const logoStyle = {
//   width: "100px",
//   height: "50px",
//   overflow: "hidden",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   fontSize: "24px",
//   fontWeight: "700",
//   color: "#2563EB",
//   letterSpacing: "1px",
//   cursor: "pointer",
// };

// const imageStyle = {
//   width: "100%",
//   height: "100%",
//   objectFit: "contain", 
// };

// const linksContainer = {
//   display: "flex",
//   gap: "35px",
// };

// const linkStyle = {
//   position: "relative",
//   textDecoration: "none",
//   color: "#1E293B",
//   fontSize: "16px",
//   fontWeight: "500",
//   padding: "10px 18px",
//   borderRadius: "8px",
//   transition: "all 0.3s ease",
// };

// const activeLink = {
//   backgroundColor: "#2563EB",
//   color: "#FFFFFF",
//   boxShadow: "0 6px 18px rgba(37,99,235,0.35)",
// };


import { useState, useEffect } from "react";
import "../index.css";

export default function Navbar() {
  const [active, setActive] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { id: "home", label: "Главная" },
    { id: "about", label: "О нас" },
    { id: "contact", label: "Контакты" },
  ];

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setScrolled(window.scrollY > 60);

  //     const sections = ["home", "about", "contact"];
  //     const scrollPosition = window.scrollY + 120;

  //     for (let section of sections) {
  //       const element = document.getElementById(section);
  //       if (!element) continue;

  //       const offsetTop = element.offsetTop;
  //       const offsetHeight = element.offsetHeight;

  //       if (
  //         scrollPosition >= offsetTop &&
  //         scrollPosition < offsetTop + offsetHeight
  //       ) {
  //         setActive(section);
  //         break;
  //       }
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   handleScroll();

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);


  useEffect(() => {
  const handleScroll = () => {
    setScrolled(window.scrollY > 60);

    const sections = ["home", "about", "contact"];
    const scrollPosition = window.scrollY + 120;

    for (let section of sections) {
      const element = document.getElementById(section);
      if (!element) continue;

      const offsetTop = element.offsetTop;
      const offsetHeight = element.offsetHeight;

      if (
        scrollPosition >= offsetTop &&
        scrollPosition < offsetTop + offsetHeight
      ) {
        setActive((prev) => {
          if (prev !== section) {
            window.history.replaceState(
              null,
              "",
              `${window.location.pathname}#${section}`
            );
            return section;
          }
          return prev;
        });

        break;
      }
    }
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll();

  return () => window.removeEventListener("scroll", handleScroll);
}, []); 

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div style={logoStyle}>
        <img alt="logo" src="gxp-logo.png" style={imageStyle} />
      </div>

      {/* Hamburger */}
      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Links */}
      <div className={`links ${menuOpen ? "active" : ""}`}>
        {navItems.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            className={active === item.id ? "active-link" : ""}
            onClick={() => setMenuOpen(false)}
          >
            {item.label}
          </a>
        ))}
      </div>
    </nav>
  );
}

/* LOGO STYLES */
const logoStyle = {
  width: "100px",
  height: "50px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const imageStyle = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
};